import React from "react";
import styled from "styled-components";
import TimeKeeper from "react-timekeeper";
import ClickOutside from "react-simple-click-outside";
import Toggle from "react-toggle";
import {
  TimeConverstion,
  stringToHours,
} from "../../../Api/Utils/ReuseableFunctions";
class TimeInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      [this.props.target]: false,
    };

    if (this.props.hours) {
      this.negativeTime = this.props.time < 0 ? true : false;
    } else {
      this.negativeTime = this.props.time
        ? this.props.time.includes("-")
        : false;
    }
  }

  getDifferenceInSeconds = (date1, date2) => {
    const diffInMs = Math.abs(date2 - date1);
    return diffInMs / 1000;
  }

  _close = (time, target) => {


  const now = new Date();
  const diff = this.getDifferenceInSeconds(now,this.clickedTime);

  console.log("time diif in _close=",diff);
  if(diff < 1){
    console.log("unwanted close event trigerred");
    return;
  }
    this.sendTimetoParent(time, target);
    this.setState({
      [target]: false,
    });
  };

  _openTime = (target) => {
    this.clickedTime= new Date();
    this.setState({
      [target]: true,
    });
  };

  sendTimetoParent = (time, target) => {

    this.modTime = this.negativeTime
      ? !this.modTime.includes("-")
        ? "-".concat(time)
        : time
      : time;
    if (this.props.hours) {
      this.modTime = stringToHours(this.modTime);
    }

    this.props.setTime(this.modTime, target);
  };

  toggleHandel = (time, target, toggle) => {
    this.negativeTime = toggle;
    this.sendTimetoParent(time, target);
  };
  covertTimeinSuitableFormat = (time) => {
    if (typeof time === "string") {
      return this.negativeTime
        ? JSON.parse(JSON.stringify(time)).split("-")[1]
        : JSON.parse(JSON.stringify(time));
    } else {
      return TimeConverstion(Math.abs(time));
    }
  };

  render() {
    const { target, style, time, showMinInt } = this.props;
    const showHide = this.state[target];
    this.modTime = this.covertTimeinSuitableFormat(time);
    return (
      <>
        <TimeEntry
          onClick={() => this._openTime(target)}
          onKeyUp={() => this._openTime(target)}
        >
          <label tabIndex="0" style={style ? style : TimeStyle}>
            {this.negativeTime ? "-" + this.modTime : this.modTime}
          </label>
        </TimeEntry>
        {showHide && (
          <div>
            <TimeTrackerWrap></TimeTrackerWrap>
            <ClickOutside
              close={() => {
                this._close(this.modTime, target);
              }}
              target={target}
            >
              <TimeTrackerInnerWrap value={showMinInt}>
                {this.props.branchId && ["0122" , "0515" , "0675" , "0635"].includes(this.props.branchId) ? (
                <TimeKeeper
                time={this.modTime}
                onChange={(newTime) =>
                  this.sendTimetoParent(newTime.formatted24, target)
                }
                onDoneClick={(newTime) =>
                  this._close(newTime.formatted24, target)
                }
                hour24Mode
                switchToMinuteOnHourSelect
                closeOnMinuteSelect
                doneButton={(newTime) => (


                  <>
                    <div
                      style={{ textAlign: "center", padding: "10px 0" }}
                      onClick={() => this._close(newTime.formatted24, target)}
                    >
                      Done
                    </div>
                    {target === "timeSheetAddtnlHours" && (
                      <ToggleButtonDiv>
                        <Togglebutton
                          defaultChecked={this.negativeTime}
                          icons={{ checked: "-", unchecked: "+" }}
                          onChange={(event) =>
                            this.toggleHandel(
                              newTime.formatted24,
                              target,
                              event.target.checked
                            )
                          }
                        />
                      </ToggleButtonDiv>
                    )}
                  </>
                )}
              />) : (
                <TimeKeeper
                  time={this.modTime}
                  onChange={(newTime) =>
                    this.sendTimetoParent(newTime.formatted24, target)
                  }
                  onDoneClick={(newTime) =>
                    this._close(newTime.formatted24, target)
                  }
                  hour24Mode
                  coarseMinutes={15}
                  switchToMinuteOnHourSelect
                  forceCoarseMinutes={!showMinInt}
                  closeOnMinuteSelect
                  doneButton={(newTime) => (


                    <>
                      <div
                        style={{ textAlign: "center", padding: "10px 0" }}
                        onClick={() => this._close(newTime.formatted24, target)}
                      >
                        Done
                      </div>
                      {target === "timeSheetAddtnlHours" && (
                        <ToggleButtonDiv>
                          <Togglebutton
                            defaultChecked={this.negativeTime}
                            icons={{ checked: "-", unchecked: "+" }}
                            onChange={(event) =>
                              this.toggleHandel(
                                newTime.formatted24,
                                target,
                                event.target.checked
                              )
                            }
                          />
                        </ToggleButtonDiv>
                      )}
                    </>
                  )}
                />
              )}
              </TimeTrackerInnerWrap>
            </ClickOutside>
          </div>
        )}
      </>
    );
  }
}
const TimeEntry = styled.div`
  display: inline-block;
`;
const TimeStyle = {
  fontSize: "21px",
  border: "1px solid #babec3",
  padding: "5px 10px",
  borderRadius: "3px",
  background: " #f1f4f9",
  letterSpacing: "1px",
};
const TimeTrackerWrap = styled.div`
  position: fixed;
  background: #000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  opacity: 0.4;
`;
const TimeTrackerInnerWrap = styled.div`
  position: fixed;
  z-index: 11;
  margin-left: -125px;
  top: 50%;
  left: 50%;
  margin-top: -150px;
  ${(props) =>
    !props.value &&
    `{
    .react-timekeeper__clock-minutes span:nth-child(1),
    .react-timekeeper__clock-minutes span:nth-child(2),
    .react-timekeeper__clock-minutes span:nth-child(4),
    .react-timekeeper__clock-minutes span:nth-child(5),
    .react-timekeeper__clock-minutes span:nth-child(7),
    .react-timekeeper__clock-minutes span:nth-child(8),
    .react-timekeeper__clock-minutes span:nth-child(10),
    .react-timekeeper__clock-minutes span:nth-child(11) {
      // visibility: hidden;
    }`}
`;
const ToggleButtonDiv = styled.div`
  left: 15px;
  position: absolute;
  top: 30px;
  .react-toggle--checked:hover:not(.react-toggle--disabled)
    .react-toggle-track {
    background-color: #00a6eb;
  }
  .react-toggle:hover:not(.react-toggle--checked) .react-toggle-track {
    background-color: #e0e0e0;
  }
  .react-toggle--checked .react-toggle-track {
    background-color: #00a6eb;
  }
  .react-toggle--checked .react-toggle-track-x {
    opacity: 0 !important;
  }
  .react-toggle--checked .react-toggle-thumb {
    left: 25px;
    border-color: #00a6eb;
  }
`;
const Togglebutton = styled(Toggle)`
  border-radius: 35px;
  font-size: 14px;
  .react-toggle-track {
    width: 50px;
    height: 28px;
    background-color: #e0e0e0;
  }
  .react-toggle-track-check {
    position: absolute;
    width: 14px;
    height: 10px;
    top: 8px;
    left: 9px;
    color: white;
    font-size: 25px;
  }
  .react-toggle-thumb {
    position: absolute;
    top: 4px;
    left: 5px;
    width: 20px;
    height: 20px;
    border: 1px solid #d9d9d9;
    border-radius: 50%;
    background-color: #fafafa;
    box-sizing: border-box;
    transition: all 0.15s ease;
  }
  .react-toggle-track-x {
    position: absolute;
    width: 10px;
    height: 10px;
    top: 8px;
    font-size: 25px;
    opacity: 1;
    transition: opacity 0.25s ease;
    color: white;
  }
  .react-toggle--checked .react-toggle-track-x {
    opacity: 0 !important;
  }
`;

export default TimeInput;
